import { useEffect } from 'react'
import { ConvertPriceToString } from '../../../Helpers/CustomConverter'
import SelectBox from 'devextreme-react/select-box';
import { useCart } from '../../../Providers/CartProvider';

const RetailerOfferSideBar = ({ basketItems, offerRequest, setOfferRequest, handleSendRetailerOffer, handleDeleteSavedOffer }) => {
    const { round2 } = useCart()
    const taxRates = [0, 8, 23]
    // const totalNetWithoutMarkupValue = parseFloat(basketItems.filter(i => i.externalArticle === false).reduce((acc, item) => ((acc + item.costNet).toFixed(2) * item.qty).toFixed(2), 0))
    // const totalNetValue = parseFloat(basketItems.reduce((acc, item) => acc + ((item.costNet + (item.costNet * item.retailerMarkup / 100)).toFixed(2) * item.qty).toFixed(2), 0))

    const totalNetWithoutMarkupValue = round2(basketItems.filter(i => i.externalArticle === false).reduce((acc, item) => acc + round2(item.costNet * item.qty), 0))
    const totalNetValue = round2(basketItems.reduce((acc, item) => {
        const costWithMarkup = round2(item.costNet * (1 + item.retailerMarkup / 100))
        const lineValue = round2(costWithMarkup * item.qty)
        return acc + lineValue;
    }, 0)
    )

    const taxRate = offerRequest.retailerTax / 100
    const totalGrossValue = round2(totalNetValue * (1 + taxRate))

    const totalMarkupValue = basketItems.reduce((acc, item) => {
        const net = round2(item.product.priceNet)
        const markupAmount = round2(net * (item.retailerMarkup / 100))
        return round2(acc + markupAmount * item.qty)
    }, 0) //Całkowity narzut dla inwestora

    //const totalMarkupValue = round2(totalNetValue - totalNetWithoutMarkupValue)

    useEffect(() => {
        setOfferRequest(prev => ({
            ...prev,
            totalPriceMarkup: totalNetValue - totalNetWithoutMarkupValue
        }))
    }, [totalNetWithoutMarkupValue, totalNetValue])

    const handleTaxRateChange = (e) => {
        setOfferRequest(prev => ({
            ...prev,
            retailerTax: e.value
        }))
    }

    // let ownProductNet = + basketItems.filter(i => i.externalArticle).reduce((acc, item) => acc + (item.costNet * item.qty).toFixed(2), 0)
    // let profitNet = ((totalNetValue - totalNetWithoutMarkupValue) + parseFloat(offerRequest.serviceNetValue)) + ownProductNet

    let profitNet = (round2(totalNetValue - totalNetWithoutMarkupValue) + round2(parseFloat(offerRequest.serviceNetValue)))

    if (!basketItems || basketItems.length === 0) {
        return null
    }
    return (<div className='ps-3 pe-3' style={{ fontSize: '16px' }}>
        <div className="row">
            <div className="col-6">
                <span>Twoja wartość zakupy</span>
            </div>
            <div className="col-6 text-end">
                <span>{ConvertPriceToString(totalNetWithoutMarkupValue)}</span>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-6">
                <span>Całkowity narzut dla inwestora</span>
            </div>
            <div className="col-6 d-flex flex justify-content-end">
                <input type='number' className='biggerArrows offer-request-input' min={0} max={100} value={round2(parseFloat(totalMarkupValue))} readOnly={true} />
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-6">
                <span>{`Stawka podatku VAT dla inwestora`}</span>
            </div>
            <div className="col-6 d-flex flex justify-content-end">
                <SelectBox
                    value={offerRequest.retailerTax}
                    items={taxRates}
                    placeholder="Stawka VAT"
                    noDataText='Brak danych'
                    onValueChanged={handleTaxRateChange}
                    displayExpr={(item) => item === null || item === undefined ? `` : `${item}%`}
                />
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-6">
                <span>Wartość całkowita netto</span>
            </div>
            <div className="col-6 text-end">
                <span>{ConvertPriceToString(totalNetValue)}</span>
            </div>
        </div>
        <div className="row mt-3 basket-page-underline">
            <div className="col-6">
                <span>Wartość całkowita brutto</span>
            </div>
            <div className="col-6 text-end mb-5">
                <span>{ConvertPriceToString(totalGrossValue)}</span>
            </div>
        </div>
        <div className="row mt-4">
            <div className="col-6">
                <b>Twój zysk netto</b>
            </div>
            <div className="col-6 text-end">
                <b>{ConvertPriceToString(profitNet)}</b>
            </div>
        </div>
        <div className="row mt-4">
            <button className='btn-app-primary' onClick={handleSendRetailerOffer}>Utwórz ofertę dla klienta</button>
        </div>
        <div className="row">
            <button className='btn-app-secondary mt-3' onClick={handleDeleteSavedOffer}>Anuluj ofertę</button>
        </div>
    </div>)
}

export default RetailerOfferSideBar